module.exports = __webpack_public_path__ + "static/img/barclays.d931da6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/customisation/barclays.png
// module id = QGvk
// module chunks = 1